import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { NotificationActionEnum, NotificationTypes } from '../enum/notification.enum';
import { NotificationConstants } from '@app/shared/constants/notificationConstants';

const { ADDED, REDUCED, REMOVED, INCREASED, UPDATED } = NotificationConstants;

export interface INotification {
  id: number;
  message?: string;
  type?: NotificationTypes;
  data?: unknown;
  action?: NotificationActionEnum;
}

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private notificationsSubject = new BehaviorSubject<INotification[]>([]);
  public notifications$ = this.notificationsSubject.asObservable();

  private idCounter = 0;

  addNotification(message?: string, type?: NotificationTypes, data?: unknown, action?: NotificationActionEnum) {
    // If no message is provided, use a default based on action
    let defaultMessage = message;
    if (!defaultMessage && action) {
      switch (action) {
        case NotificationActionEnum.ADD:
          defaultMessage = ADDED;
          break;
        case NotificationActionEnum.REMOVE:
          defaultMessage = REDUCED;
          break;
        case NotificationActionEnum.DELETE:
          defaultMessage = REMOVED;
          break;
        case NotificationActionEnum.UPDATE:
          defaultMessage = INCREASED;
          break;
        default:
          defaultMessage = UPDATED;
      }
    }
    const notification: INotification = {
      id: ++this.idCounter,
      message: defaultMessage,
      type,
      data,
      action
    };
    const currentNotifications = this.notificationsSubject.getValue();

    // Check if there's exactly one notification and reset to empty array before adding
    const updatedNotifications =
      currentNotifications.length === 1 ? [notification] : [...currentNotifications, notification];
    this.notificationsSubject.next(updatedNotifications);

    // when updating the timeout here, also update the set timeout in remove() in notification.component.ts
    setTimeout(() => this.removeNotification(notification.id), 5000);
  }

  removeNotification(id: number) {
    const currentNotifications = this.notificationsSubject.getValue();
    this.notificationsSubject.next(currentNotifications.filter((notification) => notification.id !== id));
  }
}
